"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;
var React = _interopRequireWildcard(require("react"));
var _types = require("../../types");
var _widgetContext = require("../../context/widgetContext");
var _FlatDesktop = require("./components/FlatDesktop");
var _JKDesktop = require("./components/JKDesktop");
var _FlatMobile = require("./components/FlatMobile");
var _JKMobile = require("./components/JKMobile");
var _HouseDesktop = require("./components/HouseDesktop");
var _LandDesktop = require("./components/LandDesktop");
var _HouseMobile = require("./components/HouseMobile");
var _LandMobile = require("./components/LandMobile");
var _FlatMyHome = require("./components/FlatMyHome");
var _HouseMyHome = require("./components/HouseMyHome");
var _LandMyHome = require("./components/LandMyHome");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const layoutsMap = {
  desktop: {
    [_types.EEstimationTargets.flat]: _FlatDesktop.FlatDesktop,
    [_types.EEstimationTargets.house]: _HouseDesktop.HouseDesktop,
    [_types.EEstimationTargets.land]: _LandDesktop.LandDesktop,
    [_types.EEstimationTargets.newbuilding]: _JKDesktop.JKDesktop
  },
  mobile: {
    [_types.EEstimationTargets.flat]: _FlatMobile.FlatMobile,
    [_types.EEstimationTargets.house]: _HouseMobile.HouseMobile,
    [_types.EEstimationTargets.land]: _LandMobile.LandMobile,
    [_types.EEstimationTargets.newbuilding]: _JKMobile.JKMobile
  },
  myHome: {
    [_types.EEstimationTargets.flat]: _FlatMyHome.FlatMyHome,
    [_types.EEstimationTargets.house]: _HouseMyHome.HouseMyHome,
    [_types.EEstimationTargets.land]: _LandMyHome.LandMyHome
  },
  myHomeWithRoomNumber: {
    [_types.EEstimationTargets.flat]: _FlatMyHome.FlatMyHomeWithRoomNumber,
    [_types.EEstimationTargets.house]: _HouseMyHome.HouseMyHome,
    [_types.EEstimationTargets.land]: _LandMyHome.LandMyHome
  }
};
const Layout = props => {
  const {
    isDesktop,
    isMyHome,
    withRoomNumber
  } = React.useContext(_widgetContext.widgetContext);
  const {
    estimationTargetProps: {
      value: estimationTarget
    }
  } = props;

  // Компонент для Моего дома с указанием номера квартиры
  if (isMyHome && withRoomNumber) {
    const MyHomeComponentWithRoomNumber = layoutsMap['myHomeWithRoomNumber'][estimationTarget];
    return /*#__PURE__*/React.createElement(MyHomeComponentWithRoomNumber, props);
  }

  // Компонент для Моего дома
  if (isMyHome) {
    const MyHomeComponent = layoutsMap['myHome'][estimationTarget];
    return /*#__PURE__*/React.createElement(MyHomeComponent, props);
  }

  // Компонент для Оценки недвижимости
  const Component = layoutsMap[isDesktop ? 'desktop' : 'mobile'][estimationTarget];
  return /*#__PURE__*/React.createElement(Component, props);
};
exports.Layout = Layout;
Layout.displayName = 'Layout';